import React, { useEffect, useState } from "react";
import { Outlet, useNavigate } from "react-router-dom";

const UnprotectedController = () => {
  const navigate = useNavigate();

  useEffect(() => {
    localStorage.getItem("token") ? (
      localStorage.setItem("origin", "internal")
    ) : (
      <></>
    );
    localStorage.getItem("token") ? navigate("/user/findcontact") : <></>;
  }, []);
  return (
    <div>
      <Outlet />
    </div>
  );
};

export default UnprotectedController;
